export default __webpack_public_path__ + "static/pelica-cd4738bffc8b43590724aa91662db003.jpg";